import { render, staticRenderFns } from "./departamentos.vue?vue&type=template&id=d95b5de4&"
import script from "./departamentos.vue?vue&type=script&lang=ts&"
export * from "./departamentos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports